import { AnchoredRegion } from '@microsoft/fast-foundation';
import { ChameleonElementMixin } from '../common/mixin';
export class AnchoredRegionComponent extends ChameleonElementMixin(AnchoredRegion) {
}
